import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { BaseResponse } from "../_types";

export interface ProductUnit {
  id: number;
  name: string;
  shortCode: string;
  merchantId: number;
}

export type GetProductUnitsResponse = BaseResponse<Array<ProductUnit>>;

async function getProductUnits(): Promise<GetProductUnitsResponse> {
  try {
    return (await axiosInstance.get("/Product/GetProductUnits")).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetProductUnits() {
  return useQuery<GetProductUnitsResponse, Error>(
    ["product", "units"],
    () => getProductUnits(),
    {
      staleTime: 5 * 60 * 1000, 
      cacheTime: 10 * 60 * 1000, 
    }
  );
}
